const hometabs = [
  {
    title: "在线报价接单平台",
    iconclass: "el-icon-cloudy",
    name: "baojia",
    baojiatab: [
      {
        title: "前台",
        name: "bjqiantai"
      },
      {
        title: "后台",
        name: "bjhoutai"
      }
    ],
    baojiaQianList: [
      {
        title: "众多品类",
        spanA: "20多个印刷品类报价",
        spanB: "20多个扩展种类维护",
        src: "bj_zhongduopinlei"
      },
      {
        title: "急速报价",
        spanA: "选择条件，一键报价",
        spanB: "无需等待QQ客服反馈",
        src: "bj_jisubaojia"
      },
      {
        title: "精准结果",
        spanA: "完全模拟人工报价",
        spanB: "更标准、更细致、更全面",
        src: "bj_jingzhunjieguo"
      },
      {
        title: "自定尺寸",
        spanA: "允许自定义尺寸",
        spanB: "区别于传统查询价格表",
        src: "bj_zidingyi"
      },
      {
        title: "专色报价",
        spanA: "可配置1专色至多专色",
        spanB: "灵活配置专色费和开机费",
        src: "bj_zhuansebaojia"
      },
      {
        title: "后工图解",
        spanA: "鼠标悬停后工文字",
        spanB: "悬停3秒自动出现",
        src: "bj_hougongtujie"
      },
      {
        title: "骑订连印",
        spanA: "封皮内页合并印刷",
        spanB: "为客户节省费用",
        src: "bj_qidinglianyin"
      },
      {
        title: "自带纸张",
        spanA: "客户自备纸张",
        spanB: "服务盘商和大客户",
        src: "bj_zidaizhizhang"
      },
      {
        title: "单联双联",
        spanA: "支持单联和多联版",
        spanB: "算价更合理、准确",
        src: "bj_danlianshuanglian"
      },
      {
        title: "多价比较",
        spanA: "一键报价，多种价格对别",
        spanB: "用户少操作，直达目标报价",
        src: "bj_duojiabijiao"
      },
      {
        title: "专版合版",
        spanA: "专版合版分开报价",
        spanB: "驳价更加清晰",
        src: "bj_zhuanbanheban"
      },
      {
        title: "箱包报价",
        spanA: "支持彩盒、箱包",
        spanB: "覆盖大部分箱包种类",
        src: "bj_xiangbaobaojia"
      },
      {
        title: "专属客服",
        spanA: "客户自动分配专属客服",
        spanB: "一对一服务更专业",
        src: "bj_zhuanshukefu"
      },
      {
        title: "进度跟踪",
        spanA: "订单进度实时反馈",
        spanB: "不在担心订单生产进度",
        src: "bj_jindugenzong"
      },
      {
        title: "特价支持",
        spanA: "商家特价产品，促销打折",
        spanB: "节假日宣传活动",
        src: "bj_tejiazhichi"
      },
      {
        title: "全套后工",
        spanA: "内置30多种常用后工",
        spanB: "基本上覆盖商务印品",
        src: "bj_quantaohougong"
      },
      {
        title: "在线确认",
        spanA: "用户在线确认稿件",
        spanB: "微信随时随地确认",
        src: "bj_zaixianqueren"
      },
      {
        title: "扫码付款",
        spanA: "对接支付通道",
        spanB: "直接付款到订单，方便快捷",
        src: "bj_saomafukuan"
      }
    ],
    baojiaHouList: [
      {
        title: "调价简单",
        spanA: "价格调整清晰、迅速",
        spanB: "应对市场变化",
        src: "bj_tiaojiajiandan"
      },
      {
        title: "优惠打折",
        spanA: "多套版，大数量优惠",
        spanB: "促进多接大单",
        src: "bj_youhuidazhe"
      },
      {
        title: "智能开本",
        spanA: "多维度智能开本",
        spanB: "更聪明，更全面",
        src: "bj_zhinnegkaiben"
      },
      {
        title: "全局参数",
        spanA: "全局开关设定",
        spanB: "方便自定义设置",
        src: "bj_quanjucanshu"
      },
      {
        title: "曲线价格",
        spanA: "价格不再忽高忽低",
        spanB: "抛物线价格设置",
        src: "bj_quxianjiage"
      },
      {
        title: "多套优惠",
        spanA: "多套正背版减钱",
        spanB: "对客户优惠",
        src: "bj_duotaoyouhui"
      },
      {
        title: "分区报价",
        spanA: "灵活客户报价方案",
        spanB: "不同区域不同价格",
        src: "bj_fenqubaojia"
      },
      {
        title: "基本维护",
        spanA: "基础信息管理",
        spanB: "企业自定义数据",
        src: "bj_jibenweihu"
      }
    ]
  },
  {
    title: "PDF自由组版系统",
    iconclass: "el-icon-monitor",
    name: "zuban",
    zubantab: [
      {
        title: "前台",
        name: "zbqiantai"
      },
      {
        title: "后台",
        name: "zbhoutai"
      }
    ],
    zubanQianList: [
      {
        title: "四周出血",
        spanA: "独创出血设置，一键搞定",
        spanB: "轻松调整文件出血",
        src: "pb_sizhouchuxue"
      },
      {
        title: "画册折手",
        spanA: "自定义折手和模板",
        spanB: "初始化标准折手模板",
        src: "pb_huacezheshou"
      },
      {
        title: "智能吸附",
        spanA: "靠近参考对象自动吸附",
        spanB: "快捷对齐和排列",
        src: "pb_zhinnegxifu"
      },
      {
        title: "单页画册混排",
        spanA: "单页、画册混合组版",
        spanB: "无需分开组版",
        src: "pb_duohuacehunpai"
      },
      {
        title: "多画册混排",
        spanA: "多个画册混合组版",
        spanB: "无需分开组版",
        src: "pb_danyehuacehunpai"
      },
      {
        title: "用纸设置",
        spanA: "可选择，可定义用纸",
        spanB: "拼版是否超越边缘 更加直观",
        src: "pb_yongzhishezhi"
      },
      {
        title: "洗白/爬移/代标",
        spanA: "支持洗白设置 爬移设置",
        spanB: "复杂样本拼版轻松搞定",
        src: "pb_xibaipayidaibiao"
      },
      {
        title: "自动刀版",
        spanA: "刀版文件自动生成刀版",
        spanB: "无需单独设计组合刀版",
        src: "pb_zidongdaoban"
      },
      {
        title: "实时开本",
        spanA: "实时计算大纸开本和印刷机",
        spanB: "辅助组版人正确拼版",
        src: "pb_shishikaiben"
      },
      {
        title: "断刀检查",
        spanA: "组版是自动检查断刀",
        spanB: "防止出现无法断刀情况",
        src: "pb_duandaojiancha"
      },
      {
        title: "群组/解散",
        spanA: "支持多对象组合解散",
        spanB: "",
        src: "pb_qunzujiesan"
      },
      {
        title: "智能拖版",
        spanA: "多品种智能产生多套组版",
        spanB: "降低重复组版工作",
        src: "pb_zhinnegtuoban"
      },
      {
        title: "大纸计算",
        spanA: "实时计算大纸数量和开本",
        spanB: "方便组版人员核对",
        src: "pb_dazhijisuan"
      },
      {
        title: "合版组版",
        spanA: "支持名片和单页合版快捷组版",
        spanB: "智能排列",
        src: "pb_hebanzuban"
      },
      {
        title: "拆P拆数量",
        spanA: "组版支持拆部分P，拆部分数量",
        spanB: "无需把文件进行拆分",
        src: "pb_chaiPshuliang"
      },
      {
        title: "支持多人",
        spanA: "支持多人同时组版",
        spanB: "不会出现拼版重复",
        src: "pb_zhichiduoren"
      }
    ],
    zubanHouList: [
      {
        title: "大版检查",
        spanA: "拼版错误智能检测",
        spanB: "防止各种低级错误",
        src: "pb_dabanjiancha"
      },
      {
        title: "生成传票",
        spanA: "连接ERP自动生成传票",
        spanB: "避免手工开单错误",
        src: "pb_shencghengchuanpiao"
      },
      {
        title: "开本设置",
        spanA: "基础开本维护",
        spanB: "按照印厂需求维护",
        src: "pb_kaibenweihu"
      },
      {
        title: "板材设置",
        spanA: "可用于连版校验",
        spanB: "生成传票可自动关联",
        src: "pb_bancaishezhi"
      },
      {
        title: "权限控制",
        spanA: "灵活权限设置，控制到人,防止扯皮",
        spanB: "操作简易,管理快捷",
        src: "pb_quanxiankongzhi"
      },
      {
        title: "纸张维护",
        spanA: "维护纸张类型，克重，厚度等",
        spanB: "便于前台正确使用",
        src: "pb_zhizhangweihu"
      },
      {
        title: "印机维护",
        spanA: "维护印刷机的幅面,厚度等",
        spanB: "用于印机自动判断",
        src: "pb_yinjiweihu"
      },
      {
        title: "刀版文件",
        spanA: "自动生成大版文件",
        spanB: "同时生成对应的刀版工艺单",
        src: "pb_daobanwenjian"
      },
      {
        title: "裁切指导",
        spanA: `可生成裁切文件和指导文件`,
        spanB: "机刀裁切参考",
        src: "pb_caiqiezhidao"
      },
      {
        title: "组版方案",
        spanA: "异地永久保存，多人共享",
        spanB: "不绑定个人电脑",
        src: "pb_zubanfangan"
      },
      {
        title: "远程组版",
        spanA: "服务器远程组版",
        spanB: "组版人无需等待，更快",
        src: "pb_yuanchengzuban"
      },
      {
        title: "蓝纸图",
        spanA: "支持蓝纸图自动导出并上传",
        spanB: "组版人无需手工导出",
        src: "pb_lanzhitu"
      },
      {
        title: "后工指导图",
        spanA: "",
        spanB: "",
        src: "pb_lanzhitu"
      },
      {
        title: "工艺单",
        spanA: "自动生成工艺单和图片",
        spanB: "方便后工主管审核",
        src: "pb_gongyidan"
      },
      {
        title: "库存检查",
        spanA: "库存不足自动发起采购",
        spanB: "判断最小库存",
        src: "pb_kucunjiancha"
      }
    ]
  },
  {
    title: "智能生产管理ERP系统",
    iconclass: "el-icon-setting",
    name: "erp",
    itemstyle: "margin-right: 0",
    erptab: [
      {
        title: "电脑端 / 手机端",
        name: "pc"
      }
      // {
      //   title: "电脑端",
      //   name: "pc"
      // },
      // {
      //   title: "移动端",
      //   name: "phone"
      // }
    ],
    erpPcList: [
      {
        title: "客服订单",
        spanA: "查看订单时间、",
        spanB: "类别、规格、颜色等",
        src: "erp_kefudingdan"
      },
      {
        title: "连版订单",
        spanA: "查看连版",
        spanB: "订单的有关内容",
        src: "erp_lianbandingdan"
      },
      {
        title: "订单产值",
        spanA: "订单给企业",
        spanB: "带来的利润额",
        src: "erp_dingdanchanzhi"
      },
      {
        title: "采购申请",
        spanA: "采购的物料、",
        spanB: "人员、供应商等",
        src: "pb_caigouwuliao"
      },
      {
        title: "采购订单",
        spanA: "采购的物品、",
        spanB: "数量、规格等",
        src: "pb_caigoushenqing"
      },
      {
        title: "生产传票",
        spanA: "生产的品类、",
        spanB: "规格、数量等信息",
        src: "erp_shengchanchuanpiao"
      },
      {
        title: "印刷完工",
        spanA: "可查看印刷",
        spanB: "是否结束",
        src: "erp_yinshuawangong"
      },
      {
        title: "印刷产值",
        spanA: "印刷给企业",
        spanB: "带来的利润额",
        src: "erp_yinshuachanzhi"
      },
      {
        title: "入库管理",
        spanA: "入库产品的品类、",
        spanB: "规格、数量、验货人等信息",
        src: "erp_rukuguanli"
      },
      {
        title: "出库管理",
        spanA: "出库产品、",
        spanB: "数量、领用人等信息",
        src: "erp_chukuguanli"
      },
      {
        title: "可用库存",
        spanA: "库存物品、",
        spanB: "数量等信息",
        src: "erp_keyongkucun"
      },
      {
        title: "发货计划",
        spanA: "将要发货的品类、",
        spanB: "时间等信息",
        src: "erp_fahuojihua"
      },
      {
        title: "发货记录",
        spanA: "已发货品的品类、",
        spanB: "发货人、发货时间等信息",
        src: "erp_fahuojilu"
      },
      {
        title: "客户对账单",
        spanA: "客户账务",
        spanB: "往来的单据",
        src: "erp_fahuoduizhang"
      },
      {
        title: "客户档案",
        spanA: "客户",
        spanB: "档案的查询",
        src: "erp_kehudangan"
      }
    ],
    erpPhoneList: [
      {
        title: "客服订单",
        spanA: "查看订单时间、",
        spanB: "类别、规格、颜色等",
        src: "erp_kefudingdan"
      },
      {
        title: "连版订单",
        spanA: "查看连版",
        spanB: "订单的有关内容",
        src: "erp_lianbandingdan"
      },
      {
        title: "订单产值",
        spanA: "订单给企业",
        spanB: "带来的利润额",
        src: "erp_dingdanchanzhi"
      },
      {
        title: "采购申请",
        spanA: "采购的物料、",
        spanB: "人员、供应商等",
        src: "pb_caigouwuliao"
      },
      {
        title: "采购订单",
        spanA: "采购的物品、",
        spanB: "数量、规格等",
        src: "pb_caigoushenqing"
      },
      {
        title: "生产传票",
        spanA: "生产的品类、",
        spanB: "规格、数量等信息",
        src: "erp_shengchanchuanpiao"
      },
      {
        title: "印刷完工",
        spanA: "可查看印刷",
        spanB: "是否结束",
        src: "erp_yinshuawangong"
      },
      {
        title: "印刷产值",
        spanA: "印刷给企业",
        spanB: "带来的利润额",
        src: "erp_yinshuachanzhi"
      },
      {
        title: "入库管理",
        spanA: "入库产品的品类、",
        spanB: "规格、数量、验货人等信息",
        src: "erp_rukuguanli"
      },
      {
        title: "出库管理",
        spanA: "出库产品、",
        spanB: "数量、领用人等信息",
        src: "erp_chukuguanli"
      },
      {
        title: "可用库存",
        spanA: "库存物品、",
        spanB: "数量等信息",
        src: "erp_keyongkucun"
      },
      {
        title: "发货计划",
        spanA: "将要发货的品类、",
        spanB: "时间等信息",
        src: "erp_fahuojihua"
      },
      {
        title: "发货记录",
        spanA: "已发货品的品类、",
        spanB: "发货人、发货时间等信息",
        src: "erp_fahuojilu"
      },
      {
        title: "客户对账单",
        spanA: "客户账务",
        spanB: "往来的单据",
        src: "erp_fahuoduizhang"
      },
      {
        title: "客户档案",
        spanA: "客户",
        spanB: "档案的查询",
        src: "erp_kehudangan"
      }
    ]
  }
];

export default {
  hometabs: hometabs
};



// WEBPACK FOOTER //
// ./src/api/dict.js